/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux';
import board from 'redux/reducers/board';
// import { persistReducer } from "redux-persist";
import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import business_process from 'redux/reducers/business_process';
import cvc from 'redux/reducers/cvc';
import loading from 'redux/reducers/loading';
import actionPlanAdmin from '_revamp/redux/reducers/admin/action_plan';
import dashboard_pt from '_revamp/redux/reducers/admin/dashboard/admin';
import manageDepartment from '_revamp/redux/reducers/admin/department';
import manageEmployee from '_revamp/redux/reducers/admin/employee/admin';
import initiativeAdmin from '_revamp/redux/reducers/admin/initiative';
import okrAdmin from '_revamp/redux/reducers/admin/okr';
import manageTeam from '_revamp/redux/reducers/admin/team';
import authV2 from '_revamp/redux/reducers/authV2';
import auth from './auth';
import bo from './backOffice';
import company from './company';
import dashboard from './dashboard';
import jobdesc from './jobdesc';
import matrix from './matrix';
import organization from './organization';
import profile from './profile';
import wla from './wla';

// Revamp

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['matrix', 'bo', 'organization'],
};
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['data', 'role', 'company', 'matrix'],
};
const boardPersistConfig = {
  key: 'board',
  storage,
  whitelist: ['data', 'member'],
};
const matrixPersisConfig = {
  key: 'matrix',
  storage,
  blacklist: ['matrix', 'matrix_focus'],
};
const businessProcessConfig = {
  key: 'business_process',
  storage,
  blacklist: ['business_process'],
};
const jobdescProcessConfig = {
  key: 'jobdesc',
  storage,
  whitelist: ['detail', 'list'],
};
const organizationProcessConfig = {
  key: 'organization',
  storage,
  whitelist: ['chart'],
};
const wlaConfig = {
  key: 'wla',
  storage,
  blacklist: [
    'list_status',
    'detail_status',
    'dashboard.job_level',
    'dashboard.division',
    // "list_template",
    'dashboard.departement',
    'validation',
  ],
};

const authPersistConfigV2 = {
  key: 'authV2',
  storage,
  whitelist: ['data'],
};

const BOPersistConfig = {
  key: 'bo',
  storage,
  whitelist: ['workload', 'apqc', 'feature_list', 'dashboard', 'log_list_feature', 'log', 'user', 'subscription', 'company'],
};
// const okrAdminConfig = {
//   key: "okrAdmin",
//   storage: storage,
//   whitelist: ["data"]
// };
// const initiativeAdminConfig = {
//   key: "initiativeAdmin",
//   storage: storage,
//   whitelist: ["data"]
// };
// const actionPlanAdminConfig = {
//   key: "actionplanAdmin",
//   storage: storage,
//   whitelist: ["data"]
// };
// const manageEmployeeConfig = {
//   key: "manageEmployee",
//   storage: storage,
//   whitelist: ["listEmployeeManagement"]
// };

const rootReducer = (state, action) => {
  if (action.type === 'HIT_LOGOUT') {
    localStorage.removeItem('token');
    localStorage.removeItem('phase');
    localStorage.removeItem('admin');
    localStorage.removeItem('persist:root');
    localStorage.removeItem('persist:root');
    localStorage.removeItem('persist:auth');
    localStorage.removeItem('persist:matrix');
    // localStorage.removeItem("persist:event");

    // Revamp
    localStorage.removeItem('tokenV2');
    localStorage.removeItem('persist:authV2');
    // localStorage.removeItem("initial_setup");

    state = undefined;
  }
  if (action.type === 'RESET') {
    const keys = {};
    action?.payload?.child.map((v, i) => {
      keys[v] = undefined;
    });
    state = {
      ...state,
      [action?.payload?.key]: {
        ...state[action?.payload?.key],
        ...keys,
      },
    };
  }
  if (action.type === 'HIT_RESET') {
    if (action.payload === 'business_process_index') {
      state.business_process = undefined;
    } else if (action.payload === 'jobdesc') {
      state.jobdesc = undefined;
    } else if (action.payload === 'matrix-deep') {
      state.matrix.matrix = [];
    } else if (action.payload === 'matrix') {
      state.matrix = undefined;
    } else if (action.payload === 'cvc-1') {
      state.cvc.level_2 = [];
    } else if (action.payload === 'cvc-2') {
      state.cvc.level_3 = [];
    } else if (action.payload === 'cvc-3') {
      state.cvc.level_4 = undefined;
    } else if (action.payload === 'cvc-4') {
      state.cvc.level_5 = undefined;
    } else if (action.payload === 'wla') {
      state.wla = undefined;
      localStorage.removeItem('persist:wla');
    } else if (action.payload === 'matrix_focus') {
      state.matrix.matrix_focus = [];
    } else if (action.payload === 'matrix_general') {
      state.matrix.matrix = [];
    } else if (action.payload === 'response') {
      state.okr.response = undefined;
    } else {
      // state.board = undefined;
      // state.loading = undefined;
      // state.cvc = undefined;
      // state.business_process = undefined;
      // state.dashboard = undefined;
      // // state.organization = undefined;
      // state.matrix = undefined;
      // state = undefined;
      state = {
        board: { ...state.board },
      };
    }
  }

  return appReducer(state, action);
};
const appReducer = combineReducers({
  board: persistReducer(boardPersistConfig, board),
  loading,
  cvc,
  bo: persistReducer(BOPersistConfig, bo),
  profile,
  company,
  business_process: persistReducer(businessProcessConfig, business_process),
  dashboard,
  organization: persistReducer(organizationProcessConfig, organization),
  auth: persistReducer(authPersistConfig, auth),
  matrix: persistReducer(matrixPersisConfig, matrix),
  jobdesc: persistReducer(jobdescProcessConfig, jobdesc),
  wla,

  // Revamp
  authV2: persistReducer(authPersistConfigV2, authV2),
  okr: okrAdmin,
  initiative: initiativeAdmin,
  action_plan: actionPlanAdmin,
  manageEmployee,
  manageTeam,
  manageDepartment,
  dashboard_pt,

  // persis version
  // okr: persistReducer(okrAdminConfig, okrAdmin),
  // initiative: persistReducer(initiativeAdminConfig, initiativeAdmin),
  // action_plan: persistReducer(actionPlanAdminConfig, actionPlanAdmin),
  // manageEmployee: persistReducer(manageEmployeeConfig, manageEmployee)
});

export default persistReducer(persistConfig, rootReducer);
